export default __webpack_public_path__ + "static/media/Black-Render-Square-removebg-desktop.45d0490f.png";